import { useEffect } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

const PETALS = Array.from({ length: 10 });

export const Celebration = ({ message, onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 1700);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div
      data-testid="celebration-overlay"
      className="fixed inset-0 z-[60] flex items-center justify-center pointer-events-none overflow-hidden"
    >
      {PETALS.map((_, i) => (
        <motion.span
          key={`petal-${i}`}
          className="absolute text-2xl"
          initial={{ opacity: 0, y: 40, x: 0, scale: 0.6 }}
          animate={{
            opacity: [0, 1, 1, 0],
            y: [-20, -180 - i * 12],
            x: (i % 2 ? 1 : -1) * (30 + i * 14),
            rotate: (i % 2 ? 1 : -1) * 120,
          }}
          transition={{ duration: 1.5, ease: "easeOut", delay: i * 0.03 }}
          style={{ left: "50%", top: "58%" }}
        >
          🌿
        </motion.span>
      ))}
      <motion.div
        initial={{ opacity: 0, scale: 0.85, y: 10 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ type: "spring", stiffness: 260, damping: 18 }}
        className="flex items-center gap-2 rounded-full bg-[#b1543b] text-white px-6 py-3 shadow-2xl"
      >
        <Sparkles className="h-5 w-5" />
        <span className="font-heading text-lg font-semibold">{message}</span>
      </motion.div>
    </div>
  );
};
